/* Client logo dialog (Our Clients + industry pages).
   Logo tiles are <button data-tc-client ...>; one shared <dialog> is built on first use. */
(function () {
  if (window.__tcClientModal) return;
  window.__tcClientModal = true;

  var dlg, els = {};

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'tc-client';
    dlg.setAttribute('aria-labelledby', 'tc-client-name');
    dlg.innerHTML =
      '<div class="tc-client__panel">' +
        '<div class="tc-client__top">' +
          '<p class="tc-eyebrow tc-client__eyebrow" data-industry></p>' +
          '<button type="button" class="tc-client__close" aria-label="Close" data-close>' +
            '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="tc-client__logo"><img alt="" data-img></div>' +
        '<h2 class="tc-client__name tc-display" id="tc-client-name" data-name></h2>' +
        '<div data-has-url>' +
          '<p class="tc-client__host" data-host></p>' +
          '<a class="tc-client__visit" target="_blank" rel="noopener" data-visit>' +
            '<span data-visit-label>Visit website</span>' +
            '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7M8 7h9v9"/></svg>' +
          '</a>' +
          '<p class="tc-client__note">' +
            '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.5v.5"/></svg>' +
            '<span>You’re leaving textconnects.com. <span data-name-note></span>’s website opens in a new tab and isn’t run by Text Connects.</span>' +
          '</p>' +
        '</div>' +
        '<p class="tc-client__note tc-client__note--muted" data-no-url>A brand we’ve worked with. Their website isn’t linked here.</p>' +
      '</div>';
    document.body.appendChild(dlg);
    ['industry', 'img', 'name', 'host', 'visit', 'visit-label', 'name-note', 'has-url', 'no-url'].forEach(function (k) {
      els[k] = dlg.querySelector('[data-' + k + ']');
    });
    dlg.querySelector('[data-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('tc-share-lock');
      if (dlg._opener) dlg._opener.focus();
    });
  }

  function open(btn) {
    if (!dlg) build();
    var d = btn.dataset;
    els.industry.textContent = d.industry || 'Client';
    els.industry.hidden = !d.industry;
    // Reuse the tile's already-loaded image so the logo shows instantly (no flash of the previous one).
    var tileImg = btn.querySelector('img');
    els.img.removeAttribute('src');
    els.img.src = (tileImg && (tileImg.currentSrc || tileImg.src)) || d.img || '';
    els.img.className = d.fit || '';
    els.name.textContent = d.name || '';
    els['name-note'].textContent = d.name || 'This brand';
    if (d.url) {
      els.visit.href = d.url;
      els.host.textContent = d.host || d.url;
      els['visit-label'].textContent = 'Visit ' + (d.host || 'website');
      els.visit.setAttribute('aria-label', 'Visit ' + d.name + ' website (opens in a new tab)');
      els['has-url'].hidden = false;
      els['no-url'].hidden = true;
    } else {
      els['has-url'].hidden = true;
      els['no-url'].hidden = false;
    }
    dlg._opener = btn;
    if (typeof dlg.showModal === 'function') {
      dlg.showModal();
      document.documentElement.classList.add('tc-share-lock');
    } else if (d.url) {
      window.open(d.url, '_blank', 'noopener');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tc-client]');
    if (!btn) return;
    e.preventDefault();
    open(btn);
  });
})();
